import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["searchTxt", "optionEl", "emptyEl", "statusEl"];

  // Filters options by their displayed name and exact model ID.
  // The model search input calls this as the administrator types.
  filter() {
    const query = this.searchTxtTarget.value.trim().toLowerCase();
    let hasMatches = false;

    for (const option of this.optionElTargets) {
      const isMatch = option.textContent.toLowerCase().includes(query);
      option.hidden = !isMatch;
      hasMatches ||= isMatch;
    }

    this.emptyElTarget.hidden = hasMatches;
  }

  // Keeps Enter in the search field from submitting an unspecified model.
  // The search input's Enter key action calls this helper.
  preventSearchSubmit(event) {
    event.preventDefault();
  }

  // Announces the save while Turbo submits the chosen option's name and value.
  // The model setting form calls this on submission.
  prepareSubmission() {
    this.statusElTarget.textContent = "Saving default model…";
  }
}
